import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";

const usePostSerialNum = async (serialNumber) => {

    const headerConfig = setHeaders();

    const response = await axios.post(`${config.ENDPOINTS["datalake"]}/mfg/generate_serial`,
        {
            serialNumber: serialNumber,
            headers: headerConfig
        });
    return response.data;

};

export default usePostSerialNum;

